import {
  JsonToBoolean,
  JsonToDouble,
  JsonToInt32,
  JsonToInt64,
  JsonToString,
  JsonToList,
  ArrayToJson,
  JsonToMap,
  MapToJson,
} from '../Helper/Converter';
class ABTestData_Experiment {
  get descriptor() {
    return ABTestData_Experiment.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._hasKey = false;
    this._key = null;
    this._values = [];
    this._hasServerOverride = false;
    this._serverOverride = null;
    this._hasReset = false;
    this._reset = null;
  }
  isEmpty() {
    if (this._hasKey) return false;
    if (this._values.length > 0) return false;
    if (this._hasServerOverride) return false;
    if (this._hasReset) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ABTestData_Experiment) {
      return value;
    }
    return ABTestData_Experiment.fromJson(value);
  }
  static fromJson(json) {
    const result = new ABTestData_Experiment();
    if (json.key != null) {
      result._hasKey = true;
      result._key = JsonToString.fromJson(json.key);
    }
    result._values = JsonToList(json.values, JsonToString);
    if (json.serverOverride != null) {
      result._hasServerOverride = true;
      result._serverOverride = JsonToBoolean.fromJson(json.serverOverride);
    }
    if (json.reset != null) {
      result._hasReset = true;
      result._reset = JsonToBoolean.fromJson(json.reset);
    }
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._hasKey) {
      result.key = JsonToString.toJson(this._key);
    }
    if (this._values.length > 0) {
      result.values = ArrayToJson(this._values, JsonToString);
    }
    if (this._hasServerOverride) {
      result.serverOverride = JsonToBoolean.toJson(this._serverOverride);
    }
    if (this._hasReset) {
      result.reset = JsonToBoolean.toJson(this._reset);
    }
    return result;
  }
  /**
   * @returns {string}
   */
  get key() {
    return this._hasKey ? this._key : JsonToString.default;
  }
  get hasKey() {
    return this._hasKey;
  }
  setKey(path, value) {
    return {type: 'SET', path: path.concat(['key']), value};
  }
  deleteKey(path) {
    return {type: 'DELETE', path: path.concat(['key'])};
  }
  /**
   * @returns {string[]}
   */
  get values() {
    return this._values;
  }
  addValues(path, value) {
    return {type: 'ADD', path: path.concat(['values']), value};
  }
  setValues(path, value) {
    return {type: 'SET', path: path.concat(['values']), value: ArrayToJson(value, JsonToString)};
  }
  setValuesByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['values', key]), value};
  }
  deleteValues(path) {
    return {type: 'DELETE', path: path.concat(['values'])};
  }
  deleteValuesByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['values', key])};
  }
  /**
   * @returns {boolean}
   */
  get serverOverride() {
    return this._hasServerOverride ? this._serverOverride : JsonToBoolean.default;
  }
  get hasServerOverride() {
    return this._hasServerOverride;
  }
  setServerOverride(path, value) {
    return {type: 'SET', path: path.concat(['serverOverride']), value};
  }
  deleteServerOverride(path) {
    return {type: 'DELETE', path: path.concat(['serverOverride'])};
  }
  /**
   * @returns {boolean}
   */
  get reset() {
    return this._hasReset ? this._reset : JsonToBoolean.default;
  }
  get hasReset() {
    return this._hasReset;
  }
  setReset(path, value) {
    return {type: 'SET', path: path.concat(['reset']), value};
  }
  deleteReset(path) {
    return {type: 'DELETE', path: path.concat(['reset'])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "key": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ABTestData_Experiment(this);
              copy._hasKey = true;
              copy._key = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasKey) {
                return this;
              }
              const copy = new ABTestData_Experiment(this);
              copy._hasKey = false;
              copy._key = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "values": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ABTestData_Experiment(this);
              copy._values = [];        for (let i of value) {
                copy._values.push(JsonToString.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ABTestData_Experiment(this);
              copy._values = copy._values.concat([JsonToString.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._values.length === 0) {
                return this;
              }
              const copy = new ABTestData_Experiment(this);
              copy._values = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ABTestData_Experiment(this);
              copy._values = copy._values.slice();
              copy._values[path[1]] = JsonToString.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ABTestData_Experiment(this);
              copy._values = copy._values.slice(0, path[1]).concat(copy._values.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._values.length) {
            return this;
          }
          const oldValue = this._values[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ABTestData_Experiment(this);
          copy._values = copy._values.slice();
          copy._values[key] = newValue;
          return copy;
        }
      }
      case "serverOverride": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ABTestData_Experiment(this);
              copy._hasServerOverride = true;
              copy._serverOverride = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasServerOverride) {
                return this;
              }
              const copy = new ABTestData_Experiment(this);
              copy._hasServerOverride = false;
              copy._serverOverride = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      case "reset": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ABTestData_Experiment(this);
              copy._hasReset = true;
              copy._reset = JsonToBoolean.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              if (!this._hasReset) {
                return this;
              }
              const copy = new ABTestData_Experiment(this);
              copy._hasReset = false;
              copy._reset = null;
              return copy;
            }
            default:
              return this;
          }
        } else {
          return this;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ABTestData_Experiment} other
   * @returns {ABTestData_Experiment}
   */
  merge(other) {
    const copy = new ABTestData_Experiment(this);
    if (other._hasKey) {
      copy._hasKey = true;
      copy._key = other._key;
    }
    copy._values = this._values.concat(other._values);
    if (other._hasServerOverride) {
      copy._hasServerOverride = true;
      copy._serverOverride = other._serverOverride;
    }
    if (other._hasReset) {
      copy._hasReset = true;
      copy._reset = other._reset;
    }
    return copy;
  }
}
ABTestData_Experiment.default = new ABTestData_Experiment();
class ABTestData_Experiment_Builder {
  constructor(value) {
    this._value = new ABTestData_Experiment(value);
  }
  build() {
    return new ABTestData_Experiment(this._value);
  }
  setKey(value) {
    this._value._hasKey = true;
    this._value._key = value;
    return this;
  }
  deleteKey() {
    this._value._hasKey = false;
    this._value._key = null;
    return this;
  }
  addAllValues(values) {
    this._value._values = this._value._values.concat(values);
    return this;
  }
  addValues(value) {
    this._value._values = this._value._values.concat([value]);
    return this;
  }
  setValues(index, value) {
    this._value._values = this._value._values.concat();
    this._value._values[index] = value;
    return this;
  }
  clearValues() {
    this._value._values = [];
    return this;
  }
  setServerOverride(value) {
    this._value._hasServerOverride = true;
    this._value._serverOverride = value;
    return this;
  }
  deleteServerOverride() {
    this._value._hasServerOverride = false;
    this._value._serverOverride = null;
    return this;
  }
  setReset(value) {
    this._value._hasReset = true;
    this._value._reset = value;
    return this;
  }
  deleteReset() {
    this._value._hasReset = false;
    this._value._reset = null;
    return this;
  }
}
ABTestData_Experiment.Builder = ABTestData_Experiment_Builder;
class ABTestData_Experiment_WithParent {
  /**
   * @param {ABTestData_Experiment} value
   * @param {ABTestData_Experiment_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ABTestData_Experiment.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get hasKey() {
    if (this._cachedHasKey === undefined) {
      if (this._value.hasKey) {
        this._cachedHasKey = true;
      } else {
        this._cachedHasKey = this._parent ? this._parent.hasKey : false;
      }
    }
    return this._cachedHasKey;
  }
  get key() {
    if (this._cachedKey === undefined) {
      if (this._value.hasKey) {
        this._cachedKey = this._value.key;
      } else {
        this._cachedKey = this._parent ? this._parent.key : this._value.key;
      }
    }
    return this._cachedKey;
  }
  get selfValues() {
    return this._value.values;
  }
  get inherentValues() {
    if (!this._inherentValues) {
      this._inherentValues = this._parent ? this._parent.values : [];
    }
    return this._inherentValues;
  }
  get values() {
    if (!this._allValues) {
      this._allValues = this._parent ? this._parent.values.concat(this.selfValues) : this.selfValues;
    }
    return this._allValues;
  }
  get hasServerOverride() {
    if (this._cachedHasServerOverride === undefined) {
      if (this._value.hasServerOverride) {
        this._cachedHasServerOverride = true;
      } else {
        this._cachedHasServerOverride = this._parent ? this._parent.hasServerOverride : false;
      }
    }
    return this._cachedHasServerOverride;
  }
  get serverOverride() {
    if (this._cachedServerOverride === undefined) {
      if (this._value.hasServerOverride) {
        this._cachedServerOverride = this._value.serverOverride;
      } else {
        this._cachedServerOverride = this._parent ? this._parent.serverOverride : this._value.serverOverride;
      }
    }
    return this._cachedServerOverride;
  }
  get hasReset() {
    if (this._cachedHasReset === undefined) {
      if (this._value.hasReset) {
        this._cachedHasReset = true;
      } else {
        this._cachedHasReset = this._parent ? this._parent.hasReset : false;
      }
    }
    return this._cachedHasReset;
  }
  get reset() {
    if (this._cachedReset === undefined) {
      if (this._value.hasReset) {
        this._cachedReset = this._value.reset;
      } else {
        this._cachedReset = this._parent ? this._parent.reset : this._value.reset;
      }
    }
    return this._cachedReset;
  }
  update(current, parent) {
    const result = new ABTestData_Experiment_WithParent(current, parent);
    return result;
  }
}
ABTestData_Experiment_WithParent.default = new ABTestData_Experiment_WithParent(ABTestData_Experiment.default, null);
ABTestData_Experiment.WithParent = ABTestData_Experiment_WithParent;
class ABTestData_Experiment_Descriptor {
  get key() {
    if (!this._key) {
      this._key = {
        name: "key",
        Name: "Key",
        number: 1,
        protoType: 9,
        protoName: "key",
        type: JsonToString,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._key;
  }
  get values() {
    if (!this._values) {
      this._values = {
        name: "values",
        Name: "Values",
        number: 2,
        protoType: 9,
        protoName: "values",
        type: JsonToString,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._values;
  }
  get serverOverride() {
    if (!this._serverOverride) {
      this._serverOverride = {
        name: "serverOverride",
        Name: "ServerOverride",
        number: 3,
        protoType: 8,
        protoName: "server_override",
        type: JsonToBoolean,
        options: {
          comments: "Whether the server should roll the dice instead of the client.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._serverOverride;
  }
  get reset() {
    if (!this._reset) {
      this._reset = {
        name: "reset",
        Name: "Reset",
        number: 4,
        protoType: 8,
        protoName: "reset",
        type: JsonToBoolean,
        options: {
          comments: "Whether to reroll the dice every time. This is usually used with a single value to set all clients to that value.",
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._reset;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.key,
        this.values,
        this.serverOverride,
        this.reset,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
      this._oneofs.push({
        name: "dummyOneofForKey",
        Name: "DummyOneofForKey",
        fields: [
          this.fields[0],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForServerOverride",
        Name: "DummyOneofForServerOverride",
        fields: [
          this.fields[2],
        ],
      });
      this._oneofs.push({
        name: "dummyOneofForReset",
        Name: "DummyOneofForReset",
        fields: [
          this.fields[3],
        ],
      });
    }
    return this._oneofs;
  }
}
ABTestData_Experiment.descriptor = new ABTestData_Experiment_Descriptor();
export class ABTestData {
  get descriptor() {
    return ABTestData.descriptor;
  }
  constructor(other) {
    if (other != null) {
      Object.assign(this, other);
      return;
    }
    this._experiments = [];
  }
  isEmpty() {
    if (this._experiments.length > 0) return false;
    return true;
  }
  static fromAny(value) {
    if (value instanceof ABTestData) {
      return value;
    }
    return ABTestData.fromJson(value);
  }
  static fromJson(json) {
    const result = new ABTestData();
    result._experiments = JsonToList(json.experiments, ABTestData_Experiment);
    return result;
  }
  static toJson(value) {
    return value.toJson();
  }
  toJson() {
    const result = {};
    if (this._experiments.length > 0) {
      result.experiments = ArrayToJson(this._experiments, ABTestData_Experiment);
    }
    return result;
  }
  /**
   * @returns {ABTestData_Experiment[]}
   */
  get experiments() {
    return this._experiments;
  }
  addExperiments(path, value) {
    return {type: 'ADD', path: path.concat(['experiments']), value: value.toJson()};
  }
  setExperiments(path, value) {
    return {type: 'SET', path: path.concat(['experiments']), value: ArrayToJson(value, ABTestData_Experiment)};
  }
  setExperimentsByIndex(path, key, value) {
    return {type: 'SET', path: path.concat(['experiments', key]), value: value.toJson()};
  }
  deleteExperiments(path) {
    return {type: 'DELETE', path: path.concat(['experiments'])};
  }
  deleteExperimentsByIndex(path, key) {
    return {type: 'DELETE', path: path.concat(['experiments', key])};
  }
  apply(type, path, value) {
    if (path.length === 0) {
      return this;
    }
    switch (path[0]) {
      case "experiments": {
        if (path.length === 1) {
          switch (type) {
            case 'SET': {
              const copy = new ABTestData(this);
              copy._experiments = [];        for (let i of value) {
                copy._experiments.push(ABTestData_Experiment.fromAny(i));
              }
              return copy;
            }
            case 'ADD': {
              const copy = new ABTestData(this);
              copy._experiments = copy._experiments.concat([ABTestData_Experiment.fromAny(value)]);
              return copy;
            }
            case 'DELETE': {
              if (this._experiments.length === 0) {
                return this;
              }
              const copy = new ABTestData(this);
              copy._experiments = [];
              return copy;
            }
            default:
              return this;
          }
        } else if (path.length === 2) {
          const key = path[1];
          if (key < 0 || key >= this._experiments.length) {
            return this;
          }
          switch (type) {
            case 'SET': {
              const copy = new ABTestData(this);
              copy._experiments = copy._experiments.slice();
              copy._experiments[path[1]] = ABTestData_Experiment.fromAny(value);
              return copy;
            }
            case 'DELETE': {
              const copy = new ABTestData(this);
              copy._experiments = copy._experiments.slice(0, path[1]).concat(copy._experiments.slice(path[1] + 1));
              return copy;
            }
            default:
              return this;
          }
        } else {
          const key = path[1];
          if (key < 0 || key >= this._experiments.length) {
            return this;
          }
          const oldValue = this._experiments[key];
          const newValue = oldValue.apply(type, path.slice(2), value);
          if (oldValue === newValue) {
            return this;
          }
          const copy = new ABTestData(this);
          copy._experiments = copy._experiments.slice();
          copy._experiments[key] = newValue;
          return copy;
        }
      }
      default:
        return this;
    }
  }
  /**
   * @param {ABTestData} other
   * @returns {ABTestData}
   */
  merge(other) {
    const copy = new ABTestData(this);
    copy._experiments = this._experiments.concat(other._experiments);
    return copy;
  }
}
ABTestData.default = new ABTestData();
ABTestData.Experiment = ABTestData_Experiment;
class ABTestData_Builder {
  constructor(value) {
    this._value = new ABTestData(value);
  }
  build() {
    return new ABTestData(this._value);
  }
  addAllExperiments(values) {
    this._value._experiments = this._value._experiments.concat(values);
    return this;
  }
  addExperiments(value) {
    this._value._experiments = this._value._experiments.concat([value]);
    return this;
  }
  setExperiments(index, value) {
    this._value._experiments = this._value._experiments.concat();
    this._value._experiments[index] = value;
    return this;
  }
  clearExperiments() {
    this._value._experiments = [];
    return this;
  }
}
ABTestData.Builder = ABTestData_Builder;
class ABTestData_WithParent {
  /**
   * @param {ABTestData} value
   * @param {ABTestData_WithParent} parent
   */
  constructor(value, parent) {
    this._value = value;
    this._parent = parent || null;
  }
  get descriptor() {
    return ABTestData.descriptor;
  }
  get selfValue() {
    return this._value;
  }
  get parentValue() {
    return this._parent;
  }
  get selfExperiments() {
    if (!this._selfExperiments) {
      this._selfExperiments = [];
      for (let i of this._value.experiments) {
        this._selfExperiments.push(new ABTestData_Experiment.WithParent(i, null));
      }
    }
    return this._selfExperiments;
  }
  get inherentExperiments() {
    if (!this._inherentExperiments) {
      this._inherentExperiments = this._parent ? this._parent.experiments : [];
    }
    return this._inherentExperiments;
  }
  get experiments() {
    if (!this._allExperiments) {
      this._allExperiments = this._parent ? this._parent.experiments.concat(this.selfExperiments) : this.selfExperiments;
    }
    return this._allExperiments;
  }
  update(current, parent) {
    const result = new ABTestData_WithParent(current, parent);
    if (this._selfExperiments) {
      if (this._value.experiments === current.experiments) {
        result._selfExperiments = this._selfExperiments;
      } else {
        result._selfExperiments = [];
        for (let i = 0; i < current.experiments.length; i++) {
          const oldValue = this._value.experiments[i];
          if (oldValue) {
            const oldCache = this._selfExperiments[i];
            if (oldValue === current.experiments[i]) {
              result._selfExperiments[i] = oldCache;
            } else {
              result._selfExperiments[i] = oldCache.update(current.experiments[i], null);
            }
          } else {
            result._selfExperiments[i] = new ABTestData_Experiment.WithParent(current.experiments[i], null);
          }
        }
      }
    }
    return result;
  }
}
ABTestData_WithParent.default = new ABTestData_WithParent(ABTestData.default, null);
ABTestData.WithParent = ABTestData_WithParent;
class ABTestData_Descriptor {
  get experiments() {
    if (!this._experiments) {
      this._experiments = {
        name: "experiments",
        Name: "Experiments",
        number: 1,
        protoType: 11,
        protoName: "experiments",
        type: ABTestData_Experiment,
        isRepeated: true,
        options: {
        },
        /**
         * @type {import('react').PureComponent}
         */
        customEditor: null,
      };
    }
    return this._experiments;
  }
  get fields() {
    if (!this._fields) {
      this._fields = [
        this.experiments,
      ];
    }
    return this._fields;
  }
  get oneofs() {
    if (!this._oneofs) {
      this._oneofs = [];
    }
    return this._oneofs;
  }
}
ABTestData.descriptor = new ABTestData_Descriptor();
